import * as React from 'react';
import Link from 'next/link';
import styled from 'styled-components';
import { TLD } from '@packages/common';
import { Translate, useTranslations } from '@packages/i18n';
import { getPublicRuntimeConfig } from '@helpers/getPublicRuntimeConfig';

import { Button, IconWithLabel } from '../../components';
import { Flex, Box } from '../../components/primitives';
import { media } from '../../theme';

import { Slogan } from './Slogan';
import { SearchInput, SearchInputBaseProps } from './SearchInput';

const APP_TLD = getPublicRuntimeConfig('APP_TLD');

const Container = styled(Flex)`
  max-width: 800px;
  ${media.to.lg`
    position: relative;
    top: 50%;
    transform: translateY(-50%);
    max-width: 100vw; 
    width: 100vw;
  `}
`;

const SloganStyled = styled(Slogan)`
  height: 100%;
  width: 100%;
`;

const SloganBox = styled(Box)`
  ${media.to.lg`
    display: none;
  `}
`;

const SearchBackBox = styled(Box)`
  display: none;
  ${media.to.lg`
    display: block;
  `}
`;

export interface SearchBarProps {
  toggleSearch?: VoidFunction;
  isActive?: boolean;
  showBackButton?: boolean;
  showSlogan?: boolean;
}

export const SearchBar: React.FC<SearchBarProps & SearchInputBaseProps> = ({
  toggleSearch,
  showBackButton = true,
  showSlogan = true,
  ...inputProps
}) => {
  const altText = useTranslations('filterPanelTitle') as string;
  return (
    <Container alignItems="center" className="search-input-container">
      {showBackButton ? (
        <SearchBackBox>
          <Button variant="clean" onClick={toggleSearch} data-testid="search-back-btn">
            <IconWithLabel icon="chevronLeft" color="inherit" hoverColor="primary">
              <Translate translation="back" />
            </IconWithLabel>
          </Button>
        </SearchBackBox>
      ) : null}
      {/* French slogan is wider than German and requires more space */}
      {showSlogan ? (
        <SloganBox width={APP_TLD === TLD.FR ? [0, 0, 1 / 2] : [0, 0, 1 / 3]} px={[0, 0, 3]} title={altText}>
          <Link prefetch={false} href="/">
            <a href="/">
              <SloganStyled />
            </a>
          </Link>
        </SloganBox>
      ) : null}
      <Box width={showSlogan ? [1, 1, 1, 2 / 3] : [1]} pr={showSlogan ? [2, 2, 2, 0] : [0]}>
        <SearchInput {...inputProps} />
      </Box>
    </Container>
  );
};
